import { render, staticRenderFns } from "./ParagraphView.vue?vue&type=template&id=72343892&scoped=true"
import script from "./ParagraphView.vue?vue&type=script&lang=js"
export * from "./ParagraphView.vue?vue&type=script&lang=js"
import style0 from "./ParagraphView.vue?vue&type=style&index=0&id=72343892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72343892",
  null
  
)

export default component.exports